export default () => ({
  banners: [],
  modalData: null,
  purchase: null,
})
